import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import * as missionButtonAnimation from '../../lotties/first_mission/leanbody_mission_button.json';
import { LottieIcon } from '../atoms/icons/lottie_icon';
import { MediaBreakPointUp } from '../styles/variables';
export const HomeBeginnerMissionLink = ({ classObject, onClick }) => (React.createElement("button", { type: "button", onClick: onClick, className: css(styles.link, classObject), "aria-label": "\u30D3\u30AE\u30CA\u30FC\u30DF\u30C3\u30B7\u30E7\u30F3\u3092\u898B\u308B" },
    React.createElement(LottieIcon, { lottieData: missionButtonAnimation, classObject: styles.image })));
const styles = StyleSheet.create({
    link: {
        position: 'relative',
        width: 86,
        height: 88,
        padding: 0,
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        pointerEvents: 'auto',
        [MediaBreakPointUp.MD]: {
            width: 88,
        },
    },
    image: {
        position: 'absolute',
        top: 2,
        left: 0,
        display: 'block',
        width: 90,
        height: 96,
    },
});
